export const list: Array<{ value: string; label: string; group: string }> = [
  {
    value: '{{contact.detailsUrl}}',
    label: 'Details URL',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.name}}',
    label: 'Name',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.firstname}}',
    label: 'First name',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.lastname}}',
    label: 'Last name',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.email}}',
    label: 'Email',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.telephone}}',
    label: 'Telephone',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.organization}}',
    label: 'Organization',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.interest1}}',
    label: 'Interest 1',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.interest2}}',
    label: 'Interest 2',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.campaigns}}',
    label: 'UTM Campaigns',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.goals}}',
    label: 'Goals',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.labels}}',
    label: 'Labels',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.lastVisit}}',
    label: 'Last visit',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.firstSeen}}',
    label: 'First seen',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.conversionDate}}',
    label: 'Conversion date',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.visitCount}}',
    label: 'Visit count',
    group: 'automations.triggers.groups.contact',
  },
  {
    value: '{{contact.engagementScore}}',
    label: 'Engagement score',
    group: 'automations.triggers.groups.contact',
  },

  {
    value: '{{session.goals}}',
    label: 'Goals',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.campaign}}',
    label: 'Onsite Campaign',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.totalTime}}',
    label: 'Total time',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.interest1}}',
    label: 'Interest 1',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.interest2}}',
    label: 'Interest 2',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.referrer}}',
    label: 'Referrer',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.utm_medium}}',
    label: 'UTM Medium',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.utm_source}}',
    label: 'UTM Source',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.utm_campaign}}',
    label: 'UTM Campaign',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.detailsUrl}}',
    label: 'Details URL',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.country}}',
    label: 'Country',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.Customfield}}',
    label: 'Custom field (in widget form)',
    group: 'automations.triggers.groups.session',
  },

  {
    value: '{{session.custom.pp_url}}',
    label: 'Consent: Privacy Policy URL',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.pp_version_date}}',
    label: 'Consent: Privacy policy version date',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.pp_revision_number}}',
    label: 'Consent: Privacy policy revision',
    group: 'automations.triggers.groups.session',
  },

  {
    value: '{{session.custom.pp_current_url}}',
    label: 'Consent: Context domain',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.pp_title}}',
    label: 'Consent: Context title',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.pp_text}}',
    label: 'Consent: Context text',
    group: 'automations.triggers.groups.session',
  },

  {
    value: '{{session.custom.pp_read_title}}',
    label: 'Consent: Accepted title',
    group: 'automations.triggers.groups.session',
  },
  {
    value: '{{session.custom.pp_read_url}}',
    label: 'Consent: Accepted URL',
    group: 'automations.triggers.groups.session',
  },

  {
    value: '{{date.now}}',
    label: 'Date now',
    group: 'automations.triggers.groups.date',
  },
  {
    value: '{{date.now.year}}',
    label: 'Date now (year)',
    group: 'automations.triggers.groups.date',
  },
  {
    value: '{{date.now.day}}',
    label: 'Date now (day)',
    group: 'automations.triggers.groups.date',
  },
  {
    value: '{{date.now.month}}',
    label: 'Date now (month)',
    group: 'automations.triggers.groups.date',
  },
];

export const DataForApsisOnePropType = [
  {
    displayName: 'Opt-in',
    id: 'Opt-in',
  },
  {
    displayName: 'Opt-out',
    id: 'Opt-out',
  },
];
